export const AvailableTabs =
{
    my: "my",
    other: "other",
    opco: "opco",
    tool: "tool",
    pavedRoads: "paved-roads",
} as const;

export type ProjectsTab = (typeof AvailableTabs)[keyof typeof AvailableTabs];
